module.exports = __webpack_public_path__ + "static/img/9.ab03312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/9.png
// module id = hBlo
// module chunks = 35